export default {
  labels: {
    sold_out: 'Udsolgt!',
    most_popular: '#{{rank}} mest populære',
    last_ordered: 'Sidst bestilt',
  },
};
